import { UserIVandGetScoreResponse } from "../../proto/UserIVandGetScore_pb";
import store from "../../store";
import { setIVandScore } from "../../store/ivand/actions";
import BaseHandler from "../BaseHandler";

export default class HandleUserIVandGetScoreResponse extends BaseHandler<UserIVandGetScoreResponse> {
  handle() {
    const clientGetDiscoveryResponse = this.response.toObject();
    store.dispatch(setIVandScore(clientGetDiscoveryResponse));
  }
}
